import { atom } from "recoil";
import { ocPersistAtom } from "oc/states/persist-atom";

export const taxApplicationsState = atom({
  key: "taxApplicationsState",
  default: {
    TaxDeclarationPersonal: true,
    TaxDeclarationFirstMarriedPerson: true,
    TaxDeclarationFourChildren: true,
    TaxDeclarationFamily: true,
    TaxDeclarationUnder25: true,
    TaxDecarationMotherUnder30: true,
    TaxDeclarationThreeChildren: true,
    TaxDeclarationCombined: true
  },
  effects_UNSTABLE: [ocPersistAtom],
});
